export default __webpack_public_path__ + "static/media/fao-logo.0bc32d0d.svg";